import React from "react";
import { Trash2 } from "lucide-react";
import { resolveAssetUrl } from "../../lib/api";

export const GalleryItemCard = ({ item, isFirst, isLast, onEdit, onMove, onDelete }) => (
  <div
    data-testid={`admin-gallery-item-${item.id}`}
    className="bg-white border border-gray-200 overflow-hidden"
  >
    <div className="aspect-[4/3] bg-gray-100 relative">
      <img
        src={resolveAssetUrl(item.url)}
        alt={item.label}
        loading="lazy"
        className="w-full h-full object-cover"
      />
      <div className="absolute top-2 left-2 bg-[#0A192F] text-white text-[10px] font-display uppercase tracking-wider px-2 py-0.5">
        {item.category}
      </div>
    </div>
    <div className="p-4">
      <div className="font-semibold text-[#0A192F] text-sm truncate">
        {item.label || "(no label)"}
      </div>
      <div className="mt-3 flex gap-2">
        <button
          onClick={onEdit}
          data-testid={`admin-gallery-edit-${item.id}`}
          className="flex-1 text-[11px] font-display uppercase tracking-wider border border-gray-300 py-2 hover:border-[#D4AF37] hover:text-[#D4AF37]"
        >
          Edit
        </button>
        <button
          onClick={() => onMove(-1)}
          disabled={isFirst}
          title="Move up"
          className="px-3 text-[11px] font-display border border-gray-300 hover:border-[#D4AF37] disabled:opacity-30"
        >
          ↑
        </button>
        <button
          onClick={() => onMove(1)}
          disabled={isLast}
          title="Move down"
          className="px-3 text-[11px] font-display border border-gray-300 hover:border-[#D4AF37] disabled:opacity-30"
        >
          ↓
        </button>
        <button
          onClick={() => onDelete(item.id)}
          data-testid={`admin-gallery-delete-${item.id}`}
          className="px-3 border border-gray-300 hover:border-red-500 hover:text-red-500"
        >
          <Trash2 size={12} />
        </button>
      </div>
    </div>
  </div>
);

export default GalleryItemCard;
